import * as service from "../api/service";
import { call, fork, put, take, takeLatest } from "redux-saga/effects";
import { NavLink, useNavigate } from "react-router-dom";
import serviceActions from "../slices/serviceSlice";

//공지사항 리스트
function* requestFetchNoticeList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(service.requestNoticeList, params);
  if (response) {
    yield put(serviceActions.actions.fetchNoticeListSuccess(response));
  } else {
    yield put(serviceActions.actions.fetchNoticeListFailure(err));
  }
}

//공지사항 카운트
function* requestFetchNoticeCount(payload) {
  const params = payload.payload;
  const { response, err } = yield call(service.requestNoticeCount, params);
  if (response) {
    yield put(serviceActions.actions.fetchNoticeCountSuccess(response));
  } else {
    yield put(serviceActions.actions.fetchNoticeCountFailure(err));
  }
}

//faq 리스트
function* requestFetchFaqList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(service.requestFaqList, params);
  if (response) {
    yield put(serviceActions.actions.fetchFaqListSuccess(response));
  } else {
    yield put(serviceActions.actions.fetchFaqListFailure(err));
  }
}

export default function* watchService() {
  yield takeLatest(
    serviceActions.actions.fetchNoticeList,
    requestFetchNoticeList
  );
  yield takeLatest(
    serviceActions.actions.fetchNoticeCount,
    requestFetchNoticeCount
  );
  yield takeLatest(serviceActions.actions.fetchFaqList, requestFetchFaqList);
}
